import { render, staticRenderFns } from "./ac_people.vue?vue&type=template&id=4c13db12&scoped=true"
import script from "./ac_people.vue?vue&type=script&lang=js"
export * from "./ac_people.vue?vue&type=script&lang=js"
import style0 from "./ac_people.vue?vue&type=style&index=0&id=4c13db12&prod&scoped=true&lang=css"
import style1 from "./ac_people.vue?vue&type=style&index=1&id=4c13db12&prod&scoped=true&lang=css"
import style2 from "./ac_people.vue?vue&type=style&index=2&id=4c13db12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c13db12",
  null
  
)

export default component.exports